import React, { useState, useEffect, Link } from "react";
import axios from 'axios';
import { alert_error, alert_success } from "../../AppContext.js";
import StatusBadge from "../../js/buttonstatus.jsx";
const MyTableComponent = () => {
    // Giả lập dữ liệu mẫu, thay vì truy vấn từ cơ sở dữ liệu
    const [id_orders, set_id_orders] = useState('');
    const [username, set_username] = useState('');
    const [chedo, set_chedo] = useState('');
    const [value, set_value] = useState('');
    const [note, set_note] = useState('');
    const [money, set_money] = useState('');
    const [start_count, set_start_count] = useState('');
    const [url, set_url] = useState('');
    const [status, set_status] = useState('');
    const options_status = [
        { id: 0, name: "-- Chưa chọn --", value: "" }, // option rỗng
        { id: 1, name: "Processing", value: "Processing" },
        { id: 2, name: "In progress", value: "In progress" },
        { id: 3, name: "Completed", value: "Completed" },
        { id: 4, name: "Canceled", value: "Canceled" },
    ];
    const [data, set_data] = useState([
        {
            stt: 1,
            name: "Service 1",
            money: "1000",
            id: "123",
            minorder: "10",
            category: "Category 1",
            status: "Active",
        },
        {
            stt: 2,
            name: "Service 2",
            money: "2000",
            id: "124",
            minorder: "20",
            category: "Category 2",
            status: "Inactive",
        },
        // Thêm dữ liệu mẫu ở đây
    ]);
    const fetchData = () => {
        axios.get('https://hust.media/hustadmin_v2/videos_maker.php', {
            params: {
                id_orders: id_orders,
                username: username,
                status: status,
                url: url
            }
        })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    function testFunction(response) {
        set_data(response.data);
    }
    useEffect(() => {
        fetchData();
    }, []);
    const handleInputChange1 = (event) => {
        set_username(event.target.value); // Cập nhật giá trị của id_orders
    };
    const handleInputChange2 = (event) => {
        set_id_orders(event.target.value); // Cập nhật giá trị của id_orders
    };

    const change_value = (event) => {
        set_value(event.target.value); // Cập nhật giá trị của id_orders'
    };
    const change_note = (event) => {
        set_note(event.target.value); // Cập nhật giá trị của id_orders'
    };
    const change_money = (event) => {
        set_money(event.target.value); // Cập nhật giá trị của id_orders'
    };
    const change_start_count = (event) => {
        set_start_count(event.target.value); // Cập nhật giá trị của id_orders'
    };
    const change_url = (event) => {
        set_url(event.target.value); // Cập nhật giá trị của id_orders'
    };
    const member_edit = (event) => {
        event.preventDefault(); // Ngăn trang tải lại
        // Logic để chỉnh sửa thành viên
        console.log("Member edit function called");
        axios.get('https://hust.media/hustadmin_v2/videos_maker_edit.php', {
            params: {
                id_orders: value,
                chedo: chedo,
                note: note,
                money: money,
                start_count: start_count,
                url: url
            }
        })
            .then((response) => {
                testFunction2(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    function testFunction2(response) {
        alert_success(response.data);
        fetchData();
        closeModal();
    }
    const [isModalVisible, setModalVisible] = useState(false);


    const closeModal = () => setModalVisible(false);
    const openModal = (row) => {
        set_users_edit(row); // Cập nhật giá trị của id_orders
        setModalVisible(true);
    };
    const [users_edit, set_users_edit] = useState('');
    const options = [
        { id: 1, name: 'Processing', value: 'Processing' },
        { id: 2, name: 'In progress', value: 'In progress' },
        { id: 3, name: 'Completed', value: 'Completed' },
        { id: 4, name: 'Canceled', value: 'Canceled' },
        { id: 4, name: 'edit_url', value: 'edit_url' }
    ];
    useEffect(() => {
        if (users_edit.id) {
            set_value(users_edit.id);
        }
    }, [users_edit]);
    const change_chedo = (event) => {
        const selectedValue = event.target.value;
        set_chedo(selectedValue);
        console.log(`Selected option: ${selectedValue}`);
    };
    return (

        <div className="card-body mx-2 my-2">
            <div className="flex">
                {!isModalVisible ?
                    (<></>) :
                    (
                        <div className="App">
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                                    <h2 className="text-lg font-semibold mb-2">Chỉnh sửa</h2>
                                    <form onSubmit={member_edit}>
                                        <div className="mb-4">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                                                id_orders {users_edit.id}
                                                <div>
                                                    Username {users_edit.username}
                                                </div>
                                            </label>
                                            <select
                                                id="select"
                                                value={chedo}
                                                onChange={change_chedo}
                                                className="mb-2 block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            >
                                                <option value="" disabled>Select an option</option>
                                                {options.map((option) => (
                                                    <option key={option.id} value={option.name}>
                                                        {option.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                (chedo == 'Processing' || chedo == 'In progress' || chedo == 'Completed' || chedo == 'Canceled') && (
                                                    <>                <input
                                                        onChange={change_value} // Gọi hàm handleInputChange khi có thay đổi
                                                        value={value}
                                                        type="text"
                                                        id="value"
                                                        placeholder="value"
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                    />
                                                        <input
                                                            onChange={change_note} // Gọi hàm handleInputChange khi có thay đổi
                                                            value={note}
                                                            type="text"
                                                            id="note"
                                                            placeholder="note: kết quả"
                                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                        />
                                                        <input
                                                            onChange={change_money} // Gọi hàm handleInputChange khi có thay đổi
                                                            value={money}
                                                            type="money"
                                                            id="money"
                                                            placeholder="money: tiền cộng"
                                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                        />
                                                        <input
                                                            onChange={change_start_count} // Gọi hàm handleInputChange khi có thay đổi
                                                            value={start_count}
                                                            type="start_count"
                                                            id="start_count"
                                                            placeholder="views: hiện tại"
                                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                        /></>
                                                )
                                            }
                                            {
                                                chedo == 'edit_url' && (<>
                                                    <input
                                                        onChange={change_url} // Gọi hàm handleInputChange khi có thay đổi
                                                        value={url}
                                                        type="url"
                                                        id="url"
                                                        placeholder="url: thay url"
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                    />
                                                </>)
                                            }
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <button
                                                type="submit"
                                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            >
                                                Submit
                                            </button>
                                            <button
                                                onClick={closeModal}
                                                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )
                }

           

                
                <div className="flex flex-col gap-4 w-full max-w-xl">
                    {/* Hàng 1: username + id_orders */}
                    <div className="flex gap-4">
                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="username"
                                value={username}
                                onChange={(event) => set_username(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>

                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="id_orders"
                                value={id_orders}
                                onChange={(event) => set_id_orders(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>
                    </div>

                    {/* Hàng 2: status + category */}
                    <div className="flex gap-4">
                        <div className="flex gap-2 flex-1">
                            <select
                                value={status}
                                onChange={(e) => set_status(e.target.value)}
                                className="border rounded p-2 flex-1"
                            >
                                {options_status.map((opt) => (
                                    <option key={opt.id} value={opt.value}>
                                        {opt.name}
                                    </option>
                                ))}
                            </select>
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>
                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="url"
                                value={url}
                                onChange={(event) => set_url(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full overflow-x-auto">
                <table className="table-fixed border-collapse w-full">
                    <colgroup>
                        <col className="w-1/12" />
                        <col className="w-2/12" />
                        <col className="w-1/12" />
                        <col className="w-1/12" />
                        <col className="w-3/12" />
                        <col className="w-1.5/12" />
                        <col className="w-1/12" />
                        <col className="w-1/12" />
                        <col className="w-1/12" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="border text-center py-2">id_orders</th>
                            <th className="border text-center py-2">Username</th>
                            <th className="border text-center py-2">views</th>
                            <th className="border text-center py-2">Money</th>
                            <th className="border text-center py-2">url</th>
                            <th className="border text-center py-2">note</th>
                            <th className="border text-center py-2">status</th>
                            <th className="border text-center py-2">createdate</th>
                            <th className="border text-center py-2">THAO TÁC</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, i) => (
                            <tr key={i} className="break-words">
                                <td className="border text-center py-2">{row.id}</td>
                                <td className="border text-center py-2"><b>{row.username}</b></td>
                                <td className="border text-center py-2">{row.start_count}</td>
                                <td className="border text-center py-2">{row.money}</td>
                                <td className="border text-center py-2">
                                    <a href={row.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                        {row.url}
                                    </a>
                                </td>
                                <td className="border text-center py-2">{row.note}</td>
                                <td className="border text-center py-2"><StatusBadge status={row.status} /></td>
                                <td className="border text-center py-2">
                                    <div>{row.createdate}</div>
                                    <div>{row.updatedate}</div>
                                </td>
                                <td className="border text-center py-2">
                                    <div onClick={() => openModal(row)} href={`edit-dich-vu.php?id=${row.id}`} className="btn btn-default">
                                        <i className="fas fa-edit"></i> Edit
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyTableComponent;
